import { Box, Stack, SxProps } from '@mui/material';
import RichText, { RichTextContent } from '../../../RichText';
import Optional from '../../../Optional';

export type TitleProps = {
  title?: RichTextContent;
  subtitle?: RichTextContent;
  // location?: string;
  sx?: SxProps;
};

const Titles = ({ title, subtitle, sx }: TitleProps) => {
  // const hasBoth = !!subtitle && !!location;
  return (
    <Box
      sx={{
        overflowY: 'auto',
        '&::-webkit-scrollbar': { display: 'none' },
      }}
    >
      <Stack
        spacing={2}
        sx={{
          justifyContent: 'end',
          ...sx,
        }}
      >
        <RichText
          withTypography
          color={'textPrimary'}
          variant={'subtitle1'}
          component={'h3'}
          sx={{ pb: 1 }}
        >
          {title}
        </RichText>
        <Optional condition={!!subtitle}>
          <RichText withTypography color={'textSecondary'} variant={'body2'}>
            {subtitle}
          </RichText>
          {/*<Optional condition={hasBoth}>*/}
          {/*  <CircleIcon sx={{ fontSize: 8, mx: 1 }} />*/}
          {/*</Optional>*/}
          {/*<RichText>{location}</RichText>*/}
        </Optional>
      </Stack>
    </Box>
  );
};

export default Titles;
